var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.782 13.127c-8.205 8.128-.213.21-3.48 3.448a1.333 1.333 0 01-1.868 0 1.303 1.303 0 010-1.85l3.48-3.448a1.333 1.333 0 011.868 0 1.303 1.303 0 010 1.85z",
    fill: "#9096AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.337c0 3.775-3.09 6.836-6.901 6.836-3.812 0-6.902-3.06-6.902-6.836C3.697 3.56 6.787.5 10.6.5 14.41.5 17.5 3.56 17.5 7.337zm-11.223 0c0 2.364 1.935 4.281 4.322 4.281s4.322-1.917 4.322-4.281c0-2.365-1.935-4.282-4.322-4.282S6.277 4.972 6.277 7.337z",
    fill: "#9096AA"
  })));
}
export default SvgSearch;